import { HTMLAttributes, ReactNode } from "react";

export function Card({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={`rounded-2xl border border-border bg-surface p-6 ${className}`}
            {...props}
        />
    );
}

interface StatCardProps {
    label: string;
    value: ReactNode;
    delta?: ReactNode;
    className?: string;
}

export function StatCard({ label, value, delta, className = "" }: StatCardProps) {
    return (
        <Card className={`space-y-1 ${className}`}>
            <p className="font-sans text-sm text-ink-muted">{label}</p>
            <p className="font-sans text-3xl font-semibold tracking-tight text-ink">{value}</p>
            {delta && <p className="text-sm text-success">{delta}</p>}
        </Card>
    );
}
